import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "kyuyo-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#kyuyo-tab-item",
      role: "tab",
      "aria-controls": "kyuyo"
    }, "給料")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "shouyo-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#shouyo-tab-item",
      role: "tab",
      "aria-controls": "shouyo"
    }, "賞与")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "shouyo-hikiate-kuriire-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#shouyo-hikiate-tab-item",
      role: "tab",
      "aria-controls": "shouyo-hikiate"
    }, "賞与引当金繰入額")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "taishoku-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#taishoku-tab-item",
      role: "tab",
      "aria-controls": "taishoku"
    }, "退職給付費用")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "fukuri-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#fukuri-tab-item",
      role: "tab",
      "aria-controls": "fukuri"
    }, "法定福利費")
  ])
], -1)
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "kyuyo-tab-item",
  role: "tabpanel",
  "aria-labelledby": "kyuyo-tab"
}
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "shouyo-tab-item",
  role: "tabpanel",
  "aria-labelledby": "shouyo-tab"
}
const _hoisted_7 = {
  class: "tab-pane fade",
  id: "shouyo-hikiate-tab-item",
  role: "tabpanel",
  "aria-labelledby": "shouyo-hikiate-tab"
}
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "taishoku-tab-item",
  role: "tabpanel",
  "aria-labelledby": "taishoku-tab"
}
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "fukuri-tab-item",
  role: "tabpanel",
  "aria-labelledby": "fukuri-tab"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_junsoku_setting_title = _resolveComponent("junsoku-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_kyuyohi_meisai_item_setting = _resolveComponent("kyuyohi-meisai-item-setting")!
  const _component_setting_panel = _resolveComponent("setting-panel")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_junsoku_setting_title, { "main-title": "給与費明細表" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_kyuyohi_meisai_item_setting, {
              "id-prefix": "kyuyo",
              settings: _ctx.settings.kyuryou
            }, null, 8, ["settings"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_kyuyohi_meisai_item_setting, {
              "id-prefix": "shouyo",
              settings: _ctx.settings.shouyo
            }, null, 8, ["settings"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_kyuyohi_meisai_item_setting, {
              "id-prefix": "shouyo-hikiate",
              settings: _ctx.settings.shouyoHikiate
            }, null, 8, ["settings"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_kyuyohi_meisai_item_setting, {
              "id-prefix": "taishoku",
              settings: _ctx.settings.taishoku
            }, null, 8, ["settings"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_setting_panel, {
              "panel-name": "fukuri",
              "response-setting-item": _ctx.settings.fukuri,
              onUpdateSettingItem: _ctx.onUpdateFukuri
            }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}